// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2m59E","info":"PatientInfo_info__2q2rV"};